// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2AJ1T","selects":"Documents_selects__3vlNI"};